export const environment = {
  production: false,
  // version: env.npm_package_version,
  // serverUrl: 'https://ec2-52-59-206-74.eu-central-1.compute.amazonaws.com:2018/', // Testsystem
  serverUrl: 'https://ec2.gastroguide.de/',
  mainServerUrl: 'https://ec2.gastroguide.de/',
  secondaryServerUrl: 'https://ec2.gastroguide.de/',
  ticketServerUrl: 'http://test.tickets.gastroguide.de',
  // defaultLanguage: 'de-DE',
  defaultLanguage: 'de',
  supportedLanguages: ['de-DE', 'de-Formal', 'en', 'de', 'es', 'nl', 'fr', 'it'],
  gastroPayUrl: 'https://gastropay.azurewebsites.de/api/v1.0/',
  revolutPayUrl: 'https://ms-test.gastroguide.de/',
  versionCheckURL: '/dist/version.json',
  frontendUrl: 'https://kunden.gastro.digital',
  onlineResURL: 'https://restest.gastroguide.de',
  googleTranslationUrl: 'https://translation.googleapis.com/language/translate/v2?key=',
  googleTranslationApiKey: 'AIzaSyCVGSVFC4w5IbDNwDP3Zgq1PswBH8JHiiY',
  baseUrl: 'https://test.gastro.digital/',
  baseUrlHetzner: 'https://test.gastro.digital/',
  feedbackBaseUrl: 'https://feedbacktest.gastro.digital/'
};
